if (!customElements.get('sjbjj-color-pair')) {
  customElements.define('sjbjj-color-pair', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const eventOptions = { signal: this.controller.signal };
      this.variants = JSON.parse(this.querySelector('[data-variants]').textContent);
      this.form = document.getElementById(this.dataset.formId);
      this.productInfo = this.closest('product-info');
      this.select = this.querySelector('[data-second-color]');
      this.button = this.querySelector('[data-add-pair]');
      this.buttonLabel = this.button.textContent;
      this.message = this.querySelector('[data-message]');
      this.cartLink = this.querySelector('[data-cart-link]');
      this.preview = this.querySelector('[data-preview]');
      this.productInfo.addEventListener('change', event => {
        if (event.target.name === 'id' && event.target.form === this.form) this.update();
        else if (event.target.closest('variant-selects')) this.button.disabled = true;
      }, eventOptions);
      this.select.addEventListener('change', () => this.updatePrice(), eventOptions);
      this.button.addEventListener('click', () => this.addPair(), eventOptions);
      this.update();
      this.hidden = false;
    }

    disconnectedCallback() {
      this.controller?.abort();
      this.controller = null;
    }

    currentVariant() {
      return this.variants.find(variant => String(variant.id) === this.form.querySelector('[name="id"]').value);
    }

    update() {
      const first = this.currentVariant();
      const previousColor = this.select.selectedOptions[0]?.dataset.color;
      this.select.replaceChildren();
      if (!first?.available) {
        this.button.disabled = true;
        this.querySelector('[data-summary-text]').textContent = this.dataset.unavailable;
        this.querySelector('[data-total-text]').textContent = '';
        this.preview.hidden = true;
        return;
      }
      this.variants.filter(variant => variant.available && variant.option1 === first.option1 && variant.option2 !== first.option2).forEach(variant => {
        const option = new Option(variant.option2.replace(/^Tri-Blend /, ''), variant.id);
        option.dataset.color = variant.option2;
        option.selected = variant.option2 === previousColor;
        this.select.add(option);
      });
      this.querySelector('[data-summary-text]').textContent = this.dataset.summary.replace('__size__', first.option1).replace('__color__', first.option2.replace(/^Tri-Blend /, ''));
      this.updatePrice();
    }

    updatePrice() {
      const first = this.currentVariant();
      const second = this.variants.find(variant => String(variant.id) === this.select.value);
      this.button.disabled = this.busy || !first?.available || !second?.available;
      if (!first || !second) return;
      const total = new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency: this.dataset.currency }).format((first.price + second.price) / 100);
      this.querySelector('[data-total-text]').textContent = this.dataset.total.replace('__total__', total);
      const image = second.featured_image?.src;
      this.preview.hidden = !image;
      if (image) this.preview.src = image;
      this.preview.alt = second.option2;
    }

    async addPair() {
      if (this.busy || this.button.disabled) return;
      const first = this.currentVariant();
      const second = this.variants.find(variant => String(variant.id) === this.select.value);
      if (!first?.available || !second?.available || first.id === second.id || first.option1 !== second.option1) return;
      this.busy = true;
      this.button.disabled = true;
      this.button.setAttribute('aria-busy', 'true');
      this.button.textContent = this.dataset.loading;
      this.message.hidden = true;
      this.cartLink.hidden = true;
      try {
        const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: first.id, quantity: 1 }, { id: second.id, quantity: 1 }] }),
        });
        const result = await response.json();
        if (!response.ok || result.status) throw new Error(this.dataset.error);
        window.location.assign(window.routes.cart_url);
      } catch {
        this.message.textContent = this.dataset.error;
        this.message.hidden = false;
        this.cartLink.hidden = false;
        this.busy = false;
        this.button.textContent = this.buttonLabel;
        this.button.removeAttribute('aria-busy');
        this.updatePrice();
      }
    }
  });
}
